import React, { useMemo } from "react";
import { getStorageValues } from "../../../shared/CommonFunctions";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

const isCompletedStatus = (status) => {
  const s = String(status || "").trim().toLowerCase();
  return s === "complete" || s === "completed";
};

export default function FinancePendingReport() {
  const columns = useMemo(
    () => [
      { name: "Sales #", selector: (r) => r.SalesNumber || "-" },
      { name: "Customer", selector: (r) => r.CustomerName || "-" },
      { name: "Mobile", selector: (r) => r.MobileNo || r.MobileNumber || "-" },
      { name: "Partner", selector: (r) => r.FinancePartnerName || "-" },
      { name: "Loan App #", selector: (r) => r.LoanApplicationNo || "-" },
      { name: "Status", selector: (r) => r.Status || "-" },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="financePending"
      title="Finance Pending"
      columns={columns}
      fetchConfig={{
        url: "/financeregister/getall",
        paramsBuilder: () => ({ UserId: getStorageValues("userId") }),
        transform: (data) => {
          const rows = Array.isArray(data) ? data : Array.isArray(data?.[0]) ? data[0] : [];
          return rows.filter((x) => !isCompletedStatus(x?.Status));
        },
      }}
      buildKpis={(rows) => [{ label: "Pending", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

